
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_8399_67596)"}},[_c('path',{attrs:{"d":"M12.146 10.556c-2.006-.463-3.874-.87-2.969-2.577C11.93 2.78 9.907 0 7 0 4.035 0 2.062 2.887 4.823 7.979c.932 1.718-1.006 2.124-2.97 2.577C.117 10.957 0 11.806 0 13.276L.003 14h1.164c0-1.828-.073-2.07 1.072-2.335 1.663-.383 3.233-.746 3.806-2.016.21-.464.345-1.227-.197-2.225-1.2-2.217-1.504-4.136-.83-5.266.79-1.327 3.165-1.32 3.947-.02.671 1.115.373 3.045-.818 5.295-.531 1.003-.392 1.763-.181 2.225.577 1.264 2.162 1.63 3.84 2.017 1.097.254 1.027.514 1.027 2.325h1.164l.003-.724c0-1.47-.116-2.319-1.854-2.72z","fill":"#CFC4BE"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_8399_67596"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    